import { ImageCarouselFeatureItem } from '@/client/whoopDotComContentfulClient';
import Image from 'next/image';
import { Icon, UnstyledButton } from 'ui';
import { NextGenerationLogoEyebrow } from '@/components/OPLComponents/NextGenerationCarousel/NextGenerationLogoEyebrow/NextGenerationLogoEyebrow';

export interface NextGenerationTileProps {
  item: ImageCarouselFeatureItem;
  handleSelection: (item: ImageCarouselFeatureItem) => void;
}

// Content is coming from Contentful, thus should already be translated
export function NextGenerationTile({
  item,
  handleSelection,
}: NextGenerationTileProps): JSX.Element {
  const handleItemSelection = () => {
    handleSelection(item);
  };

  return (
    <UnstyledButton
      className='flex w-full flex-col justify-center gap-2 overflow-hidden'
      onClick={handleItemSelection}
    >
      <div className='flex-start relative'>
        <div className='absolute left-0 right-0 top-0 flex w-full flex-col px-8 py-6 text-start font-semibold '>
          <span className='z-10'>
            <h3 className='text-md desktop:text-lg'>{item.setASubheading}</h3>
            <h2 className='desktop:text-2xl desktop:leading-6 text-xl leading-5 '>
              {item.setAHeading}
            </h2>
          </span>
          <span
            className='pointer-events-none absolute left-0 top-0 h-[200px] w-full bg-[linear-gradient(to_bottom,rgba(255,255,255,0.95),transparent)]'
            aria-hidden='true'
          />
        </div>
        <Image
          className='w-full rounded-3xl shadow-lg'
          data-testid='next-generation-image'
          src={item.uploadAnImage.url}
          alt={item.uploadAnImage.title}
          width={item.uploadAnImage.width}
          height={item.uploadAnImage.height}
        />
        <div
          className='absolute bottom-8 right-8 h-fit w-fit rounded-full bg-white p-3'
          data-testid='next-generation-tile-cta'
        >
          <Icon size='xs' alt='see more' color='black' variant='add' />
        </div>
      </div>
      <div className='px-4'>
        <NextGenerationLogoEyebrow item={item} />
      </div>
    </UnstyledButton>
  );
}
